export default "__VITE_ASSET__51b14f48__"